import i18next from 'i18next'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import AdminRoute from './AdminRoute'
import ClientRoute from './ClientRoute'
import AppContainer from './components/Layout/AppContainer'
import Login from './pages/Login/Login.js'
import ResetPassword from './pages/Login/ResetPassword'
import ErrorPage from './pages/ErrorPage/ErrorContent'
import { ROUTES } from './constants/Routing'
import { message } from 'antd'
import { setClearErrorMsg } from './store/handleErrorSlice'
import { useTranslation } from 'react-i18next'

function App () {
  const { t: ln_t } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const admin = useSelector((state) => state.admin)
  const err = useSelector(state => state.handleError)
  const [menu, setMenu] = useState([])

  useEffect(() => {
    const keys = { }
    if (admin.active) keys.admin = [...admin.functions.map(item => item.key), 'profile']
    if (user.active) keys.user = [...user.nowGroupFunctionsDetail.map(item => item?.key), 'profile', 'brandManagement']
    setMenu(keys)
  }, [admin.active, user.active, admin.functions, user?.nowGroupFunctionsDetail])

  useEffect(() => {
    const language = window.location.pathname.includes(ROUTES.ADMIN_ROOT) ? admin?.language : user?.language
    i18next.changeLanguage(language)
  }, [admin.language, user.language])

  const renderRoutes = (routes, role) => routes.filter(route => menu[role]?.includes(route.key) || route.key === 'apiKey')

  useEffect(() => {
    if (!err.catchError) return
    message.error(ln_t(err.errCode) || err.errMessage || 'Server Error')
    dispatch(setClearErrorMsg())
  }, [err])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<Login adminMode/>} />
        <Route path="/settingPassword/:code" element={<ResetPassword />} />
        <Route path="/admin/settingPassword/:code" element={<ResetPassword adminMode/>} />
        {/* --- Routes After Login --- */}
        <Route exact path="/*" element={
          <AppContainer>
            <Routes>
              {admin.active && renderRoutes(AdminRoute, 'admin')}
              {user.active && renderRoutes(ClientRoute, 'user')}
              <Route path="*" element={<ErrorPage />}/>
            </Routes>
          </AppContainer>
        }/>
      </Routes>
    </BrowserRouter>
  )
}

export default App
